module.exports = __webpack_public_path__ + "img/segnala.91000121.svg";